// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-home {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    border-bottom: 1px solid #EC8018;
    justify-content: start;
    align-items: center;
  }
  
  .title-home {
    margin-left: 20px;
    font-size: 14px;
    font-family: 'Ubuntu', sans-serif;
    color: #004070;
  }

  .header-home img {
    width: 20px;
    height: 20px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/header/styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd","sourcesContent":[".header-home {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    display: flex;\n    border-bottom: 1px solid #EC8018;\n    justify-content: start;\n    align-items: center;\n  }\n  \n  .title-home {\n    margin-left: 20px;\n    font-size: 14px;\n    font-family: 'Ubuntu', sans-serif;\n    color: #004070;\n  }\n\n  .header-home img {\n    width: 20px;\n    height: 20px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
